export const translations = {
  ko: {
    appTitle: "K-TourSpot",
    appSubtitle: "전국 572개 관광안내소 & 스마트 로컬 컨시어지",
    searchPlaceholder: "안내소명, 지역(서울, 제주 등), 편의시설 검색...",
    findNearMe: "내 주변",
    allRegions: "전국 전체",
    filterTitle: "상세 필터",
    targetLanguage: "외국어 안내",
    langEn: "영어 (EN)",
    langJa: "일본어 (JA)",
    langZh: "중국어 (ZH)",
    facilities: "편의 지원",
    facLuggage: "짐보관",
    facWheelchair: "휠체어/유모차",
    facWifi: "무료 Wi-Fi",
    facInterpretation: "전문 통역/해설",
    facStamp: "스탬프투어",
    statusOpen: "영업중",
    statusClosed: "영업종료",
    statusHoliday: "오늘 휴무",
    statusUnknown: "운영정보 확인",
    totalCount: "총 {count}개 안내소",
    distanceKm: "약 {km}km",
    viewOnMap: "지도 보기",
    viewDetail: "상세보기",
    callPhone: "전화걸기",
    directions: "길찾기",
    website: "공식 웹사이트",
    summerHours: "하절기 운영",
    winterHours: "동절기 운영",
    closedDay: "휴무일",
    address: "소재지 주소",
    operator: "운영기관",
    servicesProvided: "제공 혜택 및 부가서비스",
    staffCount: "평균 상주 근무인원: {count}명",
    foreignLanguages: "외국어 안내 지원",
    bookmark: "보관",
    bookmarked: "저장됨",
    tabList: "목록",
    tabMap: "지도",
    tabBenefits: "제휴/혜택",
    tabEmergency: "긴급 SOS",
    tabBookmarks: "보관함",
    tabScratchpad: "스크래치패드",
    liveUpdated: "⚡ 실시간 업데이트",
    globalDealsTitle: "🎁 외국인 & 국내 여행자 특별 제휴 할인",
    globalDealsSubtitle: "Klook 패스, 초고속 5G eSIM, 짐배송 예약 할인 혜택",
    emergencyTitle: "🚨 24시간 긴급 지원 & 1330 관광통역",
    emergencySubtitle: "한국 여행 중 위급 상황 시 원클릭 바로 연결",
    stampModalTitle: "🏅 전국 지자체 스탬프투어 안내",
    stampModalDesc: "전국 관광안내소는 지자체 스탬프투어 공식 거점입니다. 스탬프북을 수령하고 코스를 완주하여 지역사랑상품권 및 기념 특산품을 받아보세요!",
    stampModalHeader: "🏅 전국 지자체 스탬프투어 완주 사은품 가이드",
    stampModalSubtitle: "전국 171개 지자체 스탬프북 날인 & 지역상품권·기념품 100% 수령 꿀팁",
    stampStepsSectionTitle: "📌 스탬프투어 3단계 참여 가이드",
    stampStep1Title: "1단계: 스탬프북 수령 또는 모바일 앱 설치",
    stampStep1Desc: "스탬프 지원 관광안내소에서 '공식 스탬프 여권/책자'를 무료로 받거나 '올댓스탬프' 앱을 설치하세요.",
    stampStep2Title: "2단계: 주요 명소 방문 및 도장 날인",
    stampStep2Desc: "지정된 관광명소, 문화유산, 둘레길 안내소에 비치된 스탬프를 찍거나 전자 스탬프를 자동 획득합니다.",
    stampStep3Title: "3단계: 완주 인증 후 사은품 현장/우편 수령",
    stampStep3Desc: "코스 완주 후 관광안내소 현장에서 확인받아 사은품을 즉시 수령하거나 집으로 우편 배송을 신청합니다.",
    stampRewardsSectionTitle: "🎁 전국 지자체 대표 완주 혜택",
    stampRewardGiftCard: "💵 지역사랑·온누리 상품권",
    stampRewardGiftCardDesc: "전통시장 및 지역 상점에서 현금처럼 쓰는 5천원 ~ 3만원 상당 상품권",
    stampRewardGoods: "🧸 한정판 마스코트 굿즈",
    stampRewardGoodsDesc: "지역 마스코트 인형, 에코백, 키링, 머그컵, 고급 뱃지 세트",
    stampRewardFood: "🍯 프리미엄 지역 특산품",
    stampRewardFoodDesc: "명품 쌀, 전통 수제 한과, 전통차, 과일 수제청, 특산 가공식품",
    stampRewardCert: "📜 완주 메달 & 명예의 전당",
    stampRewardCertDesc: "지자체장 명의 공식 완주 인증서, 기념 메달 및 명예의 전당 등재",
    stampAppsSectionTitle: "📲 추천 모바일 스탬프투어 앱",
    btnFilterStampCenters: "📍 스탬프 지원 관광안내소 ({count}곳) 지도에서 즉시 보기",
    noResults: "검색 조건에 맞는 관광안내소가 없습니다.",
    resetFilter: "필터 초기화",
    copiedAddress: "주소가 클립보드에 복사되었습니다.",
    themeToggleDark: "다크 모드로 전환",
    themeToggleLight: "라이트 모드로 전환",
    // --- Scratchpad & Travel Toolkit (KO) ---
    scratchpadTitle: "📝 스마트 여행 스크래치패드",
    scratchpadSubtitle: "나만의 여행 코스 메모, 체크리스트, 가계부 & 여행 도우미",
    scratchpadSpotsTab: "🗺️ 여행 코스",
    scratchpadChecklistTab: "✅ 준비물",
    scratchpadExpenseTab: "💰 경비 가계부",
    scratchpadConverterTab: "💱 환율 계산기",
    scratchpadPhrasesTab: "🗣️ 필수 회화",
    addToScratchpad: "📝 수첩에 담기",
    inScratchpad: "📝 수첩에 저장됨",
    memoPlaceholder: "방문 목적이나 메모를 적어보세요 (예: 짐보관 맡기고 10시 출발!)...",
    saveMemo: "메모 저장",
    saved: "✓ 저장됨",
    visited: "방문 완료",
    notVisited: "방문 전",
    moveUp: "위로",
    moveDown: "아래로",
    deleteSpot: "삭제",
    exportItinerary: "📋 전체 일정 복사",
    itineraryCopied: "✨ 여행 일정과 메모가 클립보드에 복사되었습니다!",
    emptyScratchpad: "아직 수첩에 담긴 여행 거점이 없습니다.<br>관광안내소 카드의 [📝 수첩에 담기] 버튼을 눌러보세요!",
    spotsProgress: "📍 총 {total}개 코스 중 {visited}개 완료",
    btnKakao: "카카오맵",
    btnNaver: "네이버지도",
    btnGoogle: "Google",
    chkPassport: "여권 및 필수 신분증 지참",
    chkEsim: "5G 무제한 eSIM 또는 USIM 개통",
    chkLuggage: "관광안내소/역사 짐보관소 위치 확인",
    chkTransit: "교통카드(티머니/와우패스) 충전",
    chkAdapter: "220V 돼지코 변환 플러그 준비",
    chkHotline: "1330 24시간 관광통역 단축번호 저장",
    checklistProgress: "준비 완료도",
    addChecklistPlaceholder: "새로운 준비물 또는 할 일 입력...",
    addBtn: "추가",
    resetPresets: "기본 준비물 불러오기",
    confirmResetPresets: "기본 필수 준비물 세트를 다시 불러오시겠습니까?",
    expenseTitle: "여행 지출 가계부",
    expenseTotal: "총 지출 합계",
    expenseItemPlaceholder: "지출 항목 (예: 점심 식사, 투어 티켓...)",
    expenseAmountPlaceholder: "금액 (KRW 원)",
    noExpenses: "기록된 여행 지출 내역이 없습니다.",
    enterExpenseValid: "지출 항목명과 유효한 금액을 입력해주세요.",
    catFood: "🍴 식비",
    catTransport: "🚇 교통",
    catTicket: "🎟️ 입장권/투어",
    catShopping: "🛍️ 쇼핑",
    catEtc: "📦 기타",
    converterTitle: "실시간 기준 간이 환율 계산기",
    krw: "대한민국 원 (KRW)",
    usd: "미국 달러 (USD)",
    jpy: "일본 엔화 (JPY)",
    cny: "중국 위안화 (CNY)",
    quickAmount: "⚡ 빠른 금액",
    preset10k: "1만 원",
    preset50k: "5만 원",
    preset100k: "10만 원",
    preset500k: "50만 원",
    exchangeRateNotice: "※ 1 USD ≈ 1,380 KRW / 100 JPY ≈ 920 KRW / 1 CNY ≈ 190 KRW 기준 실시간 환산",
    phrasesTitle: "여행자 필수 한국어 서바이벌 회화",
    clickPhraseToCopy: "카드를 클릭하면 한국어 문구가 클립보드에 복사됩니다.",
    copy: "📋 복사",
    copied: "✓ 복사완료!",
    phraseWhereIsCenter: "관광안내소가 어디에 있나요?",
    phraseWhereIsCenterSub: "Where is the tourist info center? / 観光案内所はどこですか？ / 旅游咨询处在哪里？",
    phraseLuggageStorage: "짐을 맡길 수 있나요?",
    phraseLuggageStorageSub: "Can I store my luggage here? / 荷物を預けられますか？ / 可以寄存行李吗？",
    phraseTaxRefund: "택스리펀(면세) 되나요?",
    phraseTaxRefundSub: "Can I get a tax refund? / 免税(タックスリファンド)はできますか？ / 可以退税吗？",
    phraseCall1330: "통역 안내원(1330)을 연결해 주세요.",
    phraseCall1330Sub: "Please connect to 1330 hotline. / 1330通訳につないでください。 / 请接通1330翻译热线。",
    phraseHowMuch: "이거 얼마인가요?",
    phraseHowMuchSub: "How much is this? / これいくらですか？ / 这个多少钱？",
    phraseNoSpicy: "안 맵게 해주세요 (덜 맵게).",
    phraseNoSpicySub: "Please make it not spicy. / 辛くしないでください。 / 请不要放辣。",
    // --- Monetization & Travelpayouts (KO) ---
    promoBannerText: "🔥 [특가] 한국 5G 무제한 eSIM & 인기 투어 패스 최대 50% 할인 혜택 받기 ➔",
    specialDealsForSpot: "🎁 이 안내소 주변 여행자 특가 & 예약 혜택",
    dealTours: "🎟️ 특가 투어/패스 (KKday)",
    dealHotels: "🏨 주변 호텔 최저가 (Trip.com)",
    dealTiqets: "🏛️ Tiqets 고궁/명소 예매",
    dealEsim: "📱 5G 무제한 eSIM (Airalo)",
    dealWelcomePickups: "🚐 공항 픽업 (Welcome Pickups)",
    dealKiwi: "✈️ 최저가 항공권 (Kiwi.com)",
    dealLuggage: "🧳 당일 짐배송 (Goodlugg)",
    dealApplyNow: "특가 신청",
    expenseSavingsTip: "💡 경비 절약 팁: Klook/KKday 패스로 입장료와 투어를 최대 50% 할인받으세요!",
    converterBenefit: "💸 환전 수수료 0원 카드 & 5G 무제한 eSIM 즉시 개통 특가",
    // --- Viral & Foreigner Toolkit & Marketing (KO) ---
    showToTaxi: "🚖 기사님께 보여주기",
    taxiCardTitle: "택시기사님을 위한 목적지 안내",
    taxiCardHeader: "기사님, 여기로 가주세요!",
    taxiCardSubHeader: "안전하고 친절한 운행 부탁드립니다.",
    taxiCardDestination: "목적지",
    taxiCardAddress: "도로명 주소",
    taxiCardPhone: "안내소/시설 전화",
    btnCopyAddress: "주소 복사",
    btnShare: "공유하기",
    btnShareCard: "📲 친구/SNS 공유",
    sharedSuccess: "✨ 클립보드에 공유 링크가 복사되었습니다!",
    btnApple: "Apple Maps",
    cheatSheetBtn: "💡 여행 꿀팁",
    cheatSheetTitle: "💡 한국 여행 필수 생존 치트시트",
    cheatSheetSubtitle: "외국인 및 국내 여행자를 위한 실전 꿀팁 & 편의 가이드",
    csTransitTitle: "💳 1. 교통카드 완벽 정리 (T-money vs 기후동행카드)",
    csTransitDesc: "• T-money / WOWPASS: 지하철, 버스, 택시, 편의점에서 전국 호환 사용 가능합니다. 역 발권기나 편의점에서 현금으로 충전하세요.\n• 기후동행카드 (Climate Card): 서울 시내 대중교통을 정해진 기간 동안 무제한 탑승할 수 있는 여행자 패스입니다. (관광안내소 및 편의점 판매)",
    csTaxTitle: "🧾 2. 세금 즉시 환급 (Tax Refund 꿀팁)",
    csTaxDesc: "• 사후면세점(Tax Free 마크 매장)에서 1회 15,000원 이상 구매 시 여권을 제시하면 부가세를 즉시 차감 결제받을 수 있습니다.\n• 공항 출국장 키오스크에서도 영수증 바코드를 스캔하여 간편 환급받으실 수 있습니다.",
    csLuggageTitle: "🧳 3. 스마트 짐보관 (안내소 & T-Locker)",
    csLuggageDesc: "• 전국 572개 관광안내소 중 다수 거점에서 무료/유료 짐보관 서비스를 지원합니다.\n• 지하철역 내 무인 사물함(T-Locker) 및 또타라커 앱을 활용하면 더욱 쾌적하게 여행할 수 있습니다.",
    csTippingTitle: "🙅 4. 팁(No Tipping) 문화 & 식당 호출벨",
    csTippingDesc: "• 한국은 모든 식당, 카페, 택시에서 팁(Tip)을 지불할 필요가 전혀 없습니다 (모든 금액에 봉사료/부가세 포함).\n• 식당 테이블 모서리의 '호출벨(Bell)'을 누르면 직원이 바로 찾아옵니다.",
    csHotlineTitle: "📞 5. 24시간 1330 관광통역 핫라인",
    csHotlineDesc: "• 한국관광공사에서 365일 24시간 무료로 영/일/중/한 통역 및 길안내, 긴급 지원을 제공합니다. (전화: 1330)",
    pwaInstallBannerText: "📲 홈 화면에 1초 만에 앱으로 추가하고 오프라인에서도 편리하게 이용하세요!",
    pwaInstallBtn: "앱 설치하기",
    pwaDismissBtn: "다음에",
    // --- PWA Installation Guide (KO) ---
    pwaGuideTitle: "📲 홈 화면에 앱 추가 방법",
    pwaGuideSubtitle: "앱스토어 다운로드 없이 1초 만에 네이티브 앱처럼 설치하세요",
    pwaStepIos: "🍎 아이폰 / iPad (Safari) 사용자",
    pwaStepIosDesc: "1. 사파리 하단의 **[공유 버튼 ⎘]**을 탭합니다.\n2. 아래로 스크롤하여 **[홈 화면에 추가 ➕]**를 선택합니다.\n3. 우측 상단의 **[추가]**를 누르면 홈 화면에 앱이 생성됩니다!",
    pwaStepAndroid: "🤖 안드로이드 (Chrome / 삼성인터넷)",
    pwaStepAndroidDesc: "1. 브라우저 우측 상단의 **[더보기 메뉴 ⋮]**를 탭합니다.\n2. **[앱 설치]** 또는 **[홈 화면에 추가]**를 누릅니다.\n3. 설치 확인을 누르면 바탕화면에 즉시 앱이 생성됩니다!",
    pwaStepPc: "💻 PC / Mac (Chrome, Edge, Whale)",
    pwaStepPcDesc: "1. 주소창(URL) 맨 우측의 **[설치 📥]** 아이콘을 클릭합니다.\n2. **[설치]** 버튼을 누르면 독립 앱 창으로 바로 실행됩니다!",
    btnGotIt: "확인 완료"
  },
  en: {
    appTitle: "K-TourSpot",
    appSubtitle: "Korea 572 Tourist Info Centers & Smart Concierge",
    searchPlaceholder: "Search centers, cities (Seoul, Jeju...), or services...",
    findNearMe: "Near Me",
    allRegions: "All Regions",
    filterTitle: "Smart Filters",
    targetLanguage: "Language Support",
    langEn: "English (EN)",
    langJa: "Japanese (JA)",
    langZh: "Chinese (ZH)",
    facilities: "Amenities & Services",
    facLuggage: "Luggage",
    facWheelchair: "Wheelchair/Stroller",
    facWifi: "Free Wi-Fi",
    facInterpretation: "Live Guide",
    facStamp: "Stamp Tour",
    statusOpen: "Open Now",
    statusClosed: "Closed",
    statusHoliday: "Closed Today",
    statusUnknown: "Check Hours",
    totalCount: "{count} Centers Found",
    distanceKm: "Approx {km}km",
    viewOnMap: "Map View",
    viewDetail: "Details",
    callPhone: "Call",
    directions: "Directions",
    website: "Official Website",
    summerHours: "Summer Hours",
    winterHours: "Winter Hours",
    closedDay: "Closed Days",
    address: "Address",
    operator: "Operator",
    servicesProvided: "Services & Amenities",
    staffCount: "Average Staff: {count}",
    foreignLanguages: "Language Support",
    bookmark: "Save",
    bookmarked: "Saved",
    tabList: "List",
    tabMap: "Map",
    tabBenefits: "Deals",
    tabEmergency: "Emergency",
    tabBookmarks: "Saved",
    tabScratchpad: "Scratchpad",
    liveUpdated: "⚡ Live Updated",
    globalDealsTitle: "🎁 Traveler Exclusive Deals & Discounts",
    globalDealsSubtitle: "Klook Attraction Passes, 5G Unlimited eSIM & Luggage Delivery",
    emergencyTitle: "🚨 24/7 Emergency & 1330 Travel Hotline",
    emergencySubtitle: "Instant one-touch call for safety & multilingual translation",
    stampModalTitle: "🏅 Korea Local Stamp Tour Rewards",
    stampModalDesc: "Tourist info centers are official stamp tour hubs! Collect stamps along your journey to receive local gift certificates and specialty souvenirs.",
    stampModalHeader: "🏅 Korea Local Stamp Tour Completion Rewards & Guide",
    stampModalSubtitle: "Get 100% free local gift cards, souvenirs & specialty goods across 171 Korean districts",
    stampStepsSectionTitle: "📌 3-Step Stamp Tour Guide",
    stampStep1Title: "Step 1: Pick Up Stamp Book or Install App",
    stampStep1Desc: "Get the official stamp passport for free at participating tourist centers or install the All That Stamp app.",
    stampStep2Title: "Step 2: Visit Landmarks & Collect Stamps",
    stampStep2Desc: "Stamp physical ink stamps at historic sites and trail booths or automatically collect GPS e-stamps.",
    stampStep3Title: "Step 3: Verify Completion & Claim Rewards",
    stampStep3Desc: "Present your completed book at a tourist center to receive gifts on the spot or apply for home mail delivery.",
    stampRewardsSectionTitle: "🎁 Popular Rewards from Local Governments",
    stampRewardGiftCard: "💵 Local Gift Certificates",
    stampRewardGiftCardDesc: "₩5,000 ~ ₩30,000 vouchers usable like cash in local traditional markets and cafes",
    stampRewardGoods: "🧸 Exclusive Mascot Merchandise",
    stampRewardGoodsDesc: "Eco bags, keyrings, souvenir mugs, enamel badges and character plushies",
    stampRewardFood: "🍯 Premium Local Specialties",
    stampRewardFoodDesc: "Artisan traditional teas, premium rice, local honey, confectioneries and dried snacks",
    stampRewardCert: "📜 Finishers Medal & Hall of Fame",
    stampRewardCertDesc: "Official completion certificate signed by local mayors, engraved medals & digital honor roll",
    stampAppsSectionTitle: "📲 Recommended Mobile Stamp Apps",
    btnFilterStampCenters: "📍 View {count} Stamp Hub Tourist Centers on Map",
    noResults: "No tourist centers match your criteria.",
    resetFilter: "Reset Filters",
    copiedAddress: "Address copied to clipboard!",
    themeToggleDark: "Switch to Dark Mode",
    themeToggleLight: "Switch to Light Mode",
    // --- Scratchpad & Travel Toolkit (EN) ---
    scratchpadTitle: "📝 Smart Travel Scratchpad",
    scratchpadSubtitle: "Custom Itinerary Notes, Packing Checklist, Expense Ledger & Travel Toolkit",
    scratchpadSpotsTab: "🗺️ Itinerary",
    scratchpadChecklistTab: "✅ Checklist",
    scratchpadExpenseTab: "💰 Expenses",
    scratchpadConverterTab: "💱 Currency",
    scratchpadPhrasesTab: "🗣️ Survival Phrases",
    addToScratchpad: "📝 Add to Pad",
    inScratchpad: "📝 Saved in Pad",
    memoPlaceholder: "Write a note (e.g., Drop luggage at 10 AM, pick up city map)...",
    saveMemo: "Save Note",
    saved: "✓ Saved",
    visited: "Visited",
    notVisited: "Planned",
    moveUp: "Up",
    moveDown: "Down",
    deleteSpot: "Delete",
    exportItinerary: "📋 Copy Entire Itinerary",
    itineraryCopied: "✨ Travel itinerary and notes copied to clipboard!",
    emptyScratchpad: "Your travel scratchpad is currently empty.<br>Click [📝 Add to Pad] on any tourist center card!",
    spotsProgress: "📍 {visited} of {total} spots completed",
    btnKakao: "Kakao Map",
    btnNaver: "Naver Map",
    btnGoogle: "Google Maps",
    chkPassport: "Passport and required travel documents",
    chkEsim: "5G Unlimited eSIM or SIM card activation",
    chkLuggage: "Check luggage storage location at tourist center",
    chkTransit: "Top up T-Money / WOWPASS transit card",
    chkAdapter: "220V Type-C/F plug adapter",
    chkHotline: "Save 1330 24/7 travel hotline on phone",
    checklistProgress: "Packing Progress",
    addChecklistPlaceholder: "Add custom packing item or to-do...",
    addBtn: "Add",
    resetPresets: "Load Essential Presets",
    confirmResetPresets: "Reset to default essential packing items?",
    expenseTitle: "Travel Expense Ledger",
    expenseTotal: "Total Spend",
    expenseItemPlaceholder: "Expense item (e.g., Lunch, Tour ticket...)",
    expenseAmountPlaceholder: "Amount (KRW ₩)",
    noExpenses: "No travel expenses recorded yet.",
    enterExpenseValid: "Please enter an item name and valid amount.",
    catFood: "🍴 Dining",
    catTransport: "🚇 Transport",
    catTicket: "🎟️ Tickets/Tour",
    catShopping: "🛍️ Shopping",
    catEtc: "📦 Misc",
    converterTitle: "Quick Currency Converter",
    krw: "South Korean Won (KRW)",
    usd: "US Dollar (USD)",
    jpy: "Japanese Yen (JPY)",
    cny: "Chinese Yuan (CNY)",
    quickAmount: "⚡ Quick Presets",
    preset10k: "₩10K",
    preset50k: "₩50K",
    preset100k: "₩100K",
    preset500k: "₩500K",
    exchangeRateNotice: "※ Live estimates based on 1 USD ≈ 1,380 KRW / 100 JPY ≈ 920 KRW / 1 CNY ≈ 190 KRW",
    phrasesTitle: "Essential Korean Survival Phrases",
    clickPhraseToCopy: "Click any card to copy Korean phrase to clipboard.",
    copy: "📋 Copy",
    copied: "✓ Copied!",
    phraseWhereIsCenter: "Where is the tourist info center?",
    phraseWhereIsCenterSub: "gwan-gwang-an-nae-so-ga eo-di-e iss-na-yo?",
    phraseLuggageStorage: "Can I store my luggage here?",
    phraseLuggageStorageSub: "jim-eul mat-gil su iss-na-yo?",
    phraseTaxRefund: "Can I get a tax refund here?",
    phraseTaxRefundSub: "taeg-seu-li-peon-deu doe-na-yo?",
    phraseCall1330: "Please connect me to 1330 interpreter.",
    phraseCall1330Sub: "tong-yeok an-nae-won(1330) yeon-gyeol-hae ju-se-yo.",
    phraseHowMuch: "How much is this?",
    phraseHowMuchSub: "i-geo eol-ma-in-ga-yo?",
    phraseNoSpicy: "Please make it mild (not spicy).",
    phraseNoSpicySub: "an maep-ge hae-ju-se-yo.",
    // --- Monetization & Travelpayouts (EN) ---
    promoBannerText: "🔥 [Deals] Korea 5G eSIM & Top Tour Passes Up to 50% OFF ➔",
    specialDealsForSpot: "🎁 Special Travel Deals & Bookings for this Spot",
    dealTours: "🎟️ Tours & Passes (KKday)",
    dealHotels: "🏨 Nearby Hotels (Trip.com)",
    dealTiqets: "🏛️ Tiqets Palace & Attraction Tickets",
    dealEsim: "📱 5G Unlimited eSIM (Airalo)",
    dealWelcomePickups: "🚐 Airport Taxi (Welcome Pickups)",
    dealKiwi: "✈️ Cheap Flights (Kiwi.com)",
    dealLuggage: "🧳 Luggage Delivery (Goodlugg)",
    dealApplyNow: "Special Deal",
    expenseSavingsTip: "💡 Budget Tip: Save up to 50% on attraction tickets & day tours with Klook/KKday passes!",
    converterBenefit: "💸 0% FX Fee Card & Korea 5G Unlimited eSIM Instant Activation",
    // --- Viral & Foreigner Toolkit & Marketing (EN) ---
    showToTaxi: "🚖 Show to Taxi Driver",
    taxiCardTitle: "Destination Card for Taxi Driver",
    taxiCardHeader: "Driver, please take me here!",
    taxiCardSubHeader: "Please drive safely and kindly to this destination.",
    taxiCardDestination: "Destination",
    taxiCardAddress: "Road Address",
    taxiCardPhone: "Center Phone",
    btnCopyAddress: "Copy Address",
    btnShare: "Share",
    btnShareCard: "📲 Share with Friends / SNS",
    sharedSuccess: "✨ Share link copied to clipboard!",
    btnApple: "Apple Maps",
    cheatSheetBtn: "💡 Travel Guide",
    cheatSheetTitle: "💡 K-Travel Essential Survival Cheat Sheet",
    cheatSheetSubtitle: "Practical tips, transit hacks & essential survival guide for Korea travel",
    csTransitTitle: "💳 1. Korea Transit Cards (T-money vs Climate Card)",
    csTransitDesc: "• T-money / WOWPASS: Universally accepted on subways, buses, taxis & convenience stores across Korea. Top up with cash (KRW) at any station or store.\n• Climate Card: Unlimited rides on Seoul subways & buses for 1, 2, 3, 5, or 30 days! Perfect for intensive sightseeing.",
    csTaxTitle: "🧾 2. Instant Tax Refund (Tax Free Shopping)",
    csTaxDesc: "• Spend over 15,000 KRW at Tax Free certified shops, show your passport, and get VAT deducted instantly at the counter!\n• Airport departure kiosks also offer quick automated refunds with receipt barcodes.",
    csLuggageTitle: "🧳 3. Smart Luggage Storage (Info Centers & Lockers)",
    csLuggageDesc: "• Many of the 572 tourist info centers provide free or low-cost luggage holding services.\n• Use subway station T-Lockers (Tota Locker app) for hands-free travel anywhere in city centers.",
    csTippingTitle: "🙅 4. No Tipping Culture & Table Call Bells",
    csTippingDesc: "• Korea has ZERO tipping culture! Do not tip at restaurants, bars, or taxis (VAT & service are included in menu price).\n• Press the small call button on your restaurant table corner when you need service.",
    csHotlineTitle: "📞 5. 24/7 Free 1330 Travel Hotline & Interpretation",
    csHotlineDesc: "• 24/7 toll-free assistance by Korea Tourism Organization in English, Japanese, Chinese & Korean for directions, translations, and emergencies (Dial: 1330).",
    pwaInstallBannerText: "📲 Add to Home Screen in 1s for fast offline access without app store downloads!",
    pwaInstallBtn: "Install App",
    pwaDismissBtn: "Later",
    // --- PWA Installation Guide (EN) ---
    pwaGuideTitle: "📲 How to Add App to Home Screen",
    pwaGuideSubtitle: "Install instantly like a native app without app store downloads",
    pwaStepIos: "🍎 iPhone / iPad (Safari)",
    pwaStepIosDesc: "1. Tap the **Share button ⎘** at the bottom of Safari.\n2. Scroll down and select **[Add to Home Screen ➕]**.\n3. Tap **[Add]** in the top right to install on your home screen!",
    pwaStepAndroid: "🤖 Android (Chrome / Samsung Internet)",
    pwaStepAndroidDesc: "1. Tap the **Menu ⋮** in the top right of your browser.\n2. Select **[Install app]** or **[Add to Home screen]**.\n3. Confirm to create the app on your home screen!",
    pwaStepPc: "💻 PC / Mac (Chrome, Edge)",
    pwaStepPcDesc: "1. Click the **Install 📥** icon on the right side of the address bar.\n2. Click **[Install]** to launch as a standalone desktop app!",
    btnGotIt: "Got it!"
  },
  ja: {
    appTitle: "K-TourSpot",
    appSubtitle: "韓国全国572ヶ所 観光案内所＆スマートコンシェルジュ",
    searchPlaceholder: "案内所名、地域（ソウル、済州など）、サービスで検索...",
    findNearMe: "現在地",
    allRegions: "韓国全国",
    filterTitle: "絞り込み検索",
    targetLanguage: "対応言語",
    langEn: "英語 (EN)",
    langJa: "日本語 (JA)",
    langZh: "中国語 (ZH)",
    facilities: "アメニティ・便利機能",
    facLuggage: "手荷物預かり",
    facWheelchair: "車椅子/ベビーカー",
    facWifi: "無料Wi-Fi",
    facInterpretation: "専門通訳・ガイド",
    facStamp: "スタンプラリー",
    statusOpen: "営業中",
    statusClosed: "営業時間外",
    statusHoliday: "本日休業",
    statusUnknown: "時間確認",
    totalCount: "該当 {count}ヶ所",
    distanceKm: "約 {km}km",
    viewOnMap: "地図表示",
    viewDetail: "詳細を見る",
    callPhone: "電話をかける",
    directions: "道案内",
    website: "公式HP",
    summerHours: "夏季営業時間",
    winterHours: "冬季営業時間",
    closedDay: "定休日",
    address: "所在地・住所",
    operator: "運営機関",
    servicesProvided: "提供サービス・特典",
    staffCount: "常駐案内員: {count}名",
    foreignLanguages: "外国語対応",
    bookmark: "保存",
    bookmarked: "保存済み",
    tabList: "リスト",
    tabMap: "マップ",
    tabBenefits: "特典・提携",
    tabEmergency: "緊急SOS",
    tabBookmarks: "保存一覧",
    tabScratchpad: "メモ帳",
    liveUpdated: "⚡ リアルタイム更新",
    globalDealsTitle: "🎁 旅行者限定スペシャル提携割引",
    globalDealsSubtitle: "Klook割引パス、韓国5G無制限eSIM、空港手荷物配送",
    emergencyTitle: "🚨 24時間 緊急サポート＆1330 観光通訳",
    emergencySubtitle: "韓国旅行中の緊急時にワンタップで日本語通訳に直結",
    stampModalTitle: "🏅 韓国全国スタンプラリー＆特産品特典",
    stampModalDesc: "観光案内所は自治体公式スタンプラリーの拠点です。スタンプを集めて地域商品券や記念特産品をGETしましょう！",
    stampModalHeader: "🏅 韓国全国スタンプラリー完走＆記念特産品ガイド",
    stampModalSubtitle: "全国171の自治体でスタンプ帳捺印＆地域商品券や特産品を無料GET",
    stampStepsSectionTitle: "📌 スタンプラリー参加 3つの手順",
    stampStep1Title: "ステップ1: スタンプ帳受取 または アプリ導入",
    stampStep1Desc: "対応案内所で公式スタンプパスポートを無料で受け取るか、「オールザットスタンプ」アプリをインストールします。",
    stampStep2Title: "ステップ2: 主要スポット訪問＆スタンプ捺印",
    stampStep2Desc: "指定の名所や遊歩道の認証ブースでスタンプを押すか、GPS電子スタンプを獲得します。",
    stampStep3Title: "ステップ3: 完走認証＆特典・プレゼント受取",
    stampStep3Desc: "全コース達成後、案内所で提示してその場で記念品を受け取るか、郵送申請を行います。",
    stampRewardsSectionTitle: "🎁 自治体の主な完走特典＆プレゼント",
    stampRewardGiftCard: "💵 地域愛商品券（5千〜3万ウォン）",
    stampRewardGiftCardDesc: "伝統市場や提携店で現金同様に使える5,000〜30,000ウォン相当の商品券",
    stampRewardGoods: "🧸 限定キャラクターグッズ",
    stampRewardGoodsDesc: "エコバッグ、キーリング、限定マグカップ、記念バッジセットなど",
    stampRewardFood: "🍯 特産品・グルメギフト",
    stampRewardFoodDesc: "高級ブランド米、伝統韓菓子、伝統茶、特産フルーツジャムなど",
    stampRewardCert: "📜 完走記念メダル＆認定証",
    stampRewardCertDesc: "市長・郡守名義の公式認定証、記念メタルメダル、名誉の殿堂掲載",
    stampAppsSectionTitle: "📲 おすすめモバイルスタンプアプリ",
    btnFilterStampCenters: "📍 全国のスタンプ対応案内所（{count}ヶ所）を地図で見る",
    noResults: "条件に一致する観光案内所が見つかりません。",
    resetFilter: "フィルター初期化",
    copiedAddress: "住所がクリップボードにコピーされました。",
    themeToggleDark: "ダークモードへ切り替え",
    themeToggleLight: "ライトモードへ切り替え",
    // --- Scratchpad & Travel Toolkit (JA) ---
    scratchpadTitle: "📝 スマート旅行スクラッチパッド（旅メモ帳）",
    scratchpadSubtitle: "自分だけの旅程メモ、持ち物チェック、旅費家計簿＆旅行お役立ちツール",
    scratchpadSpotsTab: "🗺️ 旅程コース",
    scratchpadChecklistTab: "✅ 持ち物チェック",
    scratchpadExpenseTab: "💰 旅費メモ",
    scratchpadConverterTab: "💱 為替レート計算",
    scratchpadPhrasesTab: "🗣️ サバイバル韓国語",
    addToScratchpad: "📝 メモ帳に追加",
    inScratchpad: "📝 メモ帳に保存済",
    memoPlaceholder: "訪問予定やメモを記入（例: 10時に荷物を預けてスタンプGET）...",
    saveMemo: "メモ保存",
    saved: "✓ 保存完了",
    visited: "訪問済",
    notVisited: "予定",
    moveUp: "上へ",
    moveDown: "下へ",
    deleteSpot: "削除",
    exportItinerary: "📋 旅程全体をコピー",
    itineraryCopied: "✨ 旅程とメモがクリップボードにコピーされました！",
    emptyScratchpad: "まだメモ帳に登録されたスポットがありません。<br>案内所カードの [📝 メモ帳に追加] ボタンを押してみましょう！",
    spotsProgress: "📍 全{total}ヶ所中 {visited}ヶ所完了",
    btnKakao: "カカオマップ",
    btnNaver: "ネイバー地図",
    btnGoogle: "Googleマップ",
    chkPassport: "パスポートおよび必要書類の準備",
    chkEsim: "韓国5G無制限eSIMまたはSIM開通",
    chkLuggage: "案内所または駅のコインロッカー/荷物預かり確認",
    chkTransit: "交通カード（T-money/WOWPASS）のチャージ",
    chkAdapter: "220V変換プラグ（SE/Cタイプ）",
    chkHotline: "1330 24時間日本語観光通訳ホットラインの登録",
    checklistProgress: "準備完了度",
    addChecklistPlaceholder: "持ち物やToDoを追加...",
    addBtn: "追加",
    resetPresets: "必須持ち物プリセット読込",
    confirmResetPresets: "必須持ち物セットを再読み込みしますか？",
    expenseTitle: "旅費・出費メモ",
    expenseTotal: "支出合計",
    expenseItemPlaceholder: "項目（例: 昼食代、入場チケット...）",
    expenseAmountPlaceholder: "金額 (ウォン / KRW)",
    noExpenses: "記録された旅費データがありません。",
    enterExpenseValid: "項目名と有効な金額を入力してください。",
    catFood: "🍴 食費",
    catTransport: "🚇 交通",
    catTicket: "🎟️ チケット/体験",
    catShopping: "🛍️ ショッピング",
    catEtc: "📦 その他",
    converterTitle: "簡易為替レート換算機",
    krw: "韓国ウォン (KRW)",
    usd: "米ドル (USD)",
    jpy: "日本円 (JPY)",
    cny: "中国人民元 (CNY)",
    quickAmount: "⚡ クイック金額",
    preset10k: "1万ウォン",
    preset50k: "5万ウォン",
    preset100k: "10万ウォン",
    preset500k: "50万ウォン",
    exchangeRateNotice: "※ 1 USD ≈ 1,380 KRW / 100 JPY ≈ 920 KRW / 1 CNY ≈ 190 KRW 基準の目安計算です。",
    phrasesTitle: "旅行者必須のサバイバル韓国語フレーズ",
    clickPhraseToCopy: "カードをクリックすると韓国語テキストがコピーされます。",
    copy: "📋 コピー",
    copied: "✓ コピー完了!",
    phraseWhereIsCenter: "観光案内所はどこですか？",
    phraseWhereIsCenterSub: "クァングァン・アンネソガ オディエ イッソヨ？",
    phraseLuggageStorage: "荷物を預けられますか？",
    phraseLuggageStorageSub: "チムル マッキル ス イッソヨ？",
    phraseTaxRefund: "免税（タックスリファンド）できますか？",
    phraseTaxRefundSub: "テクスリポンドゥ デナヨ？",
    phraseCall1330: "1330日本語通訳につないでください。",
    phraseCall1330Sub: "イルサムサムゴン イルボンオ トンヨク ヨンギョレ ジュセヨ。",
    phraseHowMuch: "これいくらですか？",
    phraseHowMuchSub: "イゴ オルマエヨ？",
    phraseNoSpicy: "辛くしないでください（控えめに）。",
    phraseNoSpicySub: "アン メッケ ヘジュセヨ。",
    // --- Monetization & Travelpayouts (JA) ---
    promoBannerText: "🔥 [特価] 韓国5G無制限eSIM＆人気ツアーパス 最大50%OFF ➔",
    specialDealsForSpot: "🎁 この案内所周辺のお得な割引＆予約特典",
    dealTours: "🎟️ 特価ツアー (KKday)",
    dealHotels: "🏨 周辺ホテル (Trip.com)",
    dealTiqets: "🏛️ Tiqets 宮殿・名所チケット",
    dealEsim: "📱 5G無制限eSIM (Airalo)",
    dealWelcomePickups: "🚐 空港送迎タクシー (Welcome Pickups)",
    dealKiwi: "✈️ 最安値航空券 (Kiwi.com)",
    dealLuggage: "🧳 手荷物当日配送 (Goodlugg)",
    dealApplyNow: "特典申込み",
    expenseSavingsTip: "💡 節約のヒント: Klook/KKdayパスで観光スポットやツアーを最大50%割引！",
    converterBenefit: "💸 為替手数料無料カード＆韓国5G無制限eSIM即時開通",
    // --- Viral & Foreigner Toolkit & Marketing (JA) ---
    showToTaxi: "🚖 タクシー運転手に見せる",
    taxiCardTitle: "タクシー運転手向け 目的地案内カード",
    taxiCardHeader: "運転手さん、ここまでお願いします！",
    taxiCardSubHeader: "安全運転でどうぞよろしくお願いいたします。",
    taxiCardDestination: "目的地",
    taxiCardAddress: "道路名住所",
    taxiCardPhone: "案内所・施設電話",
    btnCopyAddress: "住所コピー",
    btnShare: "共有",
    btnShareCard: "📲 友達/SNSに共有",
    sharedSuccess: "✨ 共有リンクをクリップボードにコピーしました！",
    btnApple: "Apple Maps",
    cheatSheetBtn: "💡 旅行ガイド",
    cheatSheetTitle: "💡 韓国旅行 必須サバイバルガイド",
    cheatSheetSubtitle: "外国人・国内旅行者のための実践お役立ち裏ワザ＆便利ガイド",
    csTransitTitle: "💳 1. 交通カード徹底比較（T-money vs 気候同行カード）",
    csTransitDesc: "• T-money / WOWPASS: 韓国全国の地下鉄、バス、タクシー、コンビニで利用可能。駅の券売機やコンビニで現金(KRW)チャージできます。\n• 気候同行カード (Climate Card): ソウル市内の地下鉄・バスが期間内乗り放題になるお得な旅行者パス（案内所・コンビニで販売）。",
    csTaxTitle: "🧾 2. 即時免税＆税金還付 (Tax Refund)",
    csTaxDesc: "• Tax Free加盟店で1回15,000ウォン以上購入時、パスポート提示でその場で消費税が即時免税されます。\n• 空港の出国エリアにある専用キオスクでもレシートのバーコードをかざして簡単還付！",
    csLuggageTitle: "🧳 3. 手荷物預かりの裏ワザ（案内所＆コインロッカー）",
    csLuggageDesc: "• 全国572ヶ所の観光案内所の多くで無料または低価格の手荷物一時預かりサービスを提供しています。\n• 地下鉄駅構内のT-Locker（無人ロッカー）も便利です。",
    csTippingTitle: "🙅 4. チップ不要文化＆呼び出しベル",
    csTippingDesc: "• 韓国では飲食店、タクシー、ホテルでのチップは一切不要です（サービス料・税込み）。\n• 食堂のテーブルの端にある「呼び出しベル」を押せばスタッフが来てくれます。",
    csHotlineTitle: "📞 5. 24時間 1330 無料観光通訳ホットライン",
    csHotlineDesc: "• 韓国観光公社が365日24時間、日本語・英語・中国語・韓国語で無料通訳・道案内・緊急対応を提供しています（電話: 1330）。",
    pwaInstallBannerText: "📲 ホーム画面に1秒でアプリ追加！オフラインでも快適に利用できます！",
    pwaInstallBtn: "アプリをインストール",
    pwaDismissBtn: "後で",
    // --- PWA Installation Guide (JA) ---
    pwaGuideTitle: "📲 ホーム画面にアプリを追加する方法",
    pwaGuideSubtitle: "アプリストア不要！1秒でネイティブアプリのように簡単追加",
    pwaStepIos: "🍎 iPhone / iPad (Safari) ユーザー",
    pwaStepIosDesc: "1. Safari画面下部の**共有ボタン ⎘**をタップします。\n2. 下にスクロールして**[ホーム画面に追加 ➕]**を選択します。\n3. 右上の**[追加]**をタップすれば完了です！",
    pwaStepAndroid: "🤖 Android (Chrome / Galaxy)",
    pwaStepAndroidDesc: "1. ブラウザ右上の**メニュー ⋮**をタップします。\n2. **[アプリをインストール]**または**[ホーム画面に追加]**を選択します。\n3. インストールを許可すれば完了です！",
    pwaStepPc: "💻 PC / Mac (Chrome, Edge)",
    pwaStepPcDesc: "1. アドレスバー右端の**[インストール 📥]**アイコンをクリックします。\n2. **[インストール]**をクリックすると専用ウィンドウで起動します！",
    btnGotIt: "確認しました"
  },
  zh: {
    appTitle: "K-TourSpot",
    appSubtitle: "全韩国572处 官方旅游咨询中心与智能向导",
    searchPlaceholder: "搜索咨询处、地区（首尔、济州等）或便民服务...",
    findNearMe: "我的附近",
    allRegions: "韩国全境",
    filterTitle: "智能筛选",
    targetLanguage: "外语咨询服务",
    langEn: "英语 (EN)",
    langJa: "日语 (JA)",
    langZh: "中文 (ZH)",
    facilities: "便民设施与服务",
    facLuggage: "行李寄存",
    facWheelchair: "轮椅/婴儿车",
    facWifi: "免费Wi-Fi",
    facInterpretation: "人工讲解/翻译",
    facStamp: "盖章打卡",
    statusOpen: "营业中",
    statusClosed: "已打烊",
    statusHoliday: "今日休息",
    statusUnknown: "营业时间核实",
    totalCount: "共找到 {count} 处咨询处",
    distanceKm: "约 {km}公里",
    viewOnMap: "地图查看",
    viewDetail: "详情",
    callPhone: "拨打电话",
    directions: "导航路线",
    website: "官方网站",
    summerHours: "夏季营业时间",
    winterHours: "冬季营业时间",
    closedDay: "休息日",
    address: "详细地址",
    operator: "运营机构",
    servicesProvided: "提供的便民福利与服务",
    staffCount: "常驻工作人员: {count}人",
    foreignLanguages: "支持外语咨询",
    bookmark: "收藏",
    bookmarked: "已收藏",
    tabList: "列表",
    tabMap: "地图",
    tabBenefits: "特惠/合作",
    tabEmergency: "紧急求助",
    tabBookmarks: "我的收藏",
    tabScratchpad: "旅行便签",
    liveUpdated: "⚡ 实时更新",
    globalDealsTitle: "🎁 游客专属折扣与官方合作预订",
    globalDealsSubtitle: "Klook景点通票、5G无限流量eSIM、机场行李配送折扣",
    emergencyTitle: "🚨 24小时紧急救援与 1330 旅游多语热线",
    emergencySubtitle: "遇到紧急情况或语言不通时一键直通中文求助服务",
    stampModalTitle: "🏅 全韩各地方政府打卡盖章与纪念品兑换",
    stampModalDesc: "旅游咨询处是官方认证的盖章打卡中心！收集印章完成路线即可领取当地消费券和精美特产礼物。",
    stampModalHeader: "🏅 全韩各地方政府打卡盖章通关奖励与兑换指南",
    stampModalSubtitle: "全韩171个地方政府官方认证盖章，100%免费领取消费券与限定纪念品",
    stampStepsSectionTitle: "📌 打卡盖章通关3步指南",
    stampStep1Title: "第1步：领取纸质打卡册或安装打卡APP",
    stampStep1Desc: "在支持盖章的旅游咨询处免费领取官方打卡护照，或下载安装 All That Stamp 等移动APP。",
    stampStep2Title: "第2步：前往核心景点完成打卡盖章",
    stampStep2Desc: "在指定景点或步道盖章点加盖实体印章，或通过手机GPS自动获取电子印章。",
    stampStep3Title: "第3步：完成认证并领取精美奖励",
    stampStep3Desc: "通关后在咨询处出示打卡册即刻现场领奖，或申请邮寄直达家中。",
    stampRewardsSectionTitle: "🎁 地方政府热门通关奖励一览",
    stampRewardGiftCard: "💵 地方消费券 / 礼品券",
    stampRewardGiftCardDesc: "面值5,000至30,000韩元，可在传统市场与当地商户直接当现金使用",
    stampRewardGoods: "🧸 城市吉祥物限定周边",
    stampRewardGoodsDesc: "环保布袋、钥匙扣、限定马克杯、精美纪念徽章套盒等",
    stampRewardFood: "🍯 地方特色高端农特产",
    stampRewardFoodDesc: "优质产地大米、传统手工韩果、养生茶礼盒及特色风味食品",
    stampRewardCert: "📜 官方通关奖牌与荣誉证书",
    stampRewardCertDesc: "地方政府首长签署的官方通关证书、定制纪念奖牌及荣誉榜登载",
    stampAppsSectionTitle: "📲 推荐移动打卡APP",
    btnFilterStampCenters: "📍 在地图上查看全韩支持盖章打卡的咨询处（共{count}处）",
    noResults: "未找到符合筛选条件的旅游咨询处。",
    resetFilter: "重置所有筛选",
    copiedAddress: "地址已成功复制到剪贴板！",
    themeToggleDark: "切换至深色模式",
    themeToggleLight: "切换至浅色模式",
    // --- Scratchpad & Travel Toolkit (ZH) ---
    scratchpadTitle: "📝 智能旅行便签本（旅行助手）",
    scratchpadSubtitle: "个性化行程笔记、行李清单、记账与实用出行工具",
    scratchpadSpotsTab: "🗺️ 行程路线",
    scratchpadChecklistTab: "✅ 必备清单",
    scratchpadExpenseTab: "💰 记账本",
    scratchpadConverterTab: "💱 汇率换算",
    scratchpadPhrasesTab: "🗣️ 必备常用语",
    addToScratchpad: "📝 加入便签",
    inScratchpad: "📝 已加入便签",
    memoPlaceholder: "填写行程备注（如：10点寄存行李并领取地图）...",
    saveMemo: "保存备注",
    saved: "✓ 已保存",
    visited: "已打卡",
    notVisited: "计划中",
    moveUp: "上移",
    moveDown: "下移",
    deleteSpot: "删除",
    exportItinerary: "📋 复制完整行程",
    itineraryCopied: "✨ 行程与备忘录已成功复制到剪贴板！",
    emptyScratchpad: "旅行便签中暂无打卡点。<br>点击咨询处卡片上的 [📝 加入便签] 即可添加！",
    spotsProgress: "📍 共{total}处打卡点，已打卡{visited}处",
    btnKakao: "Kakao地图",
    btnNaver: "Naver地图",
    btnGoogle: "谷歌地图",
    chkPassport: "护照及必要出行证件",
    chkEsim: "韩国5G无限流量eSIM或电话卡激活",
    chkLuggage: "确认咨询处或车站行李寄存点位置",
    chkTransit: "交通卡（T-Money / WOWPASS）充值",
    chkAdapter: "220V德标转换插头（双圆孔）",
    chkHotline: "保存 1330 24小时中文旅游热线",
    checklistProgress: "准备进度",
    addChecklistPlaceholder: "添加自定义清单或待办事项...",
    addBtn: "添加",
    resetPresets: "加载必备清单推荐",
    confirmResetPresets: "是否重新加载默认必备清单？",
    expenseTitle: "旅行记账本",
    expenseTotal: "累计支出",
    expenseItemPlaceholder: "支出项目（如：午餐、门票...）",
    expenseAmountPlaceholder: "金额（韩元 / KRW）",
    noExpenses: "暂无旅行支出记录。",
    enterExpenseValid: "请输入支出项目和有效金额。",
    catFood: "🍴 餐饮",
    catTransport: "🚇 交通",
    catTicket: "🎟️ 门票/体验",
    catShopping: "🛍️ 购物",
    catEtc: "📦 其他",
    converterTitle: "简易实时参考汇率计算器",
    krw: "韩元 (KRW)",
    usd: "美元 (USD)",
    jpy: "日元 (JPY)",
    cny: "中国人民元 (CNY)",
    quickAmount: "⚡ 快捷金额",
    preset10k: "1万韩元",
    preset50k: "5万韩元",
    preset100k: "10万韩元",
    preset500k: "50万韩元",
    exchangeRateNotice: "※ 参考汇率：1 USD ≈ 1,380 KRW / 100 JPY ≈ 920 KRW / 1 CNY ≈ 190 KRW",
    phrasesTitle: "韩国旅行必备生存韩语短句",
    clickPhraseToCopy: "点击卡片即可复制韩语文案到剪贴板。",
    copy: "📋 复制",
    copied: "✓ 已复制!",
    phraseWhereIsCenter: "请问旅游咨询处在哪里？",
    phraseWhereIsCenterSub: "gwan-gwang-an-nae-so-ga eo-di-e iss-na-yo?",
    phraseLuggageStorage: "请问这里可以寄存行李吗？",
    phraseLuggageStorageSub: "jim-eul mat-gil su iss-na-yo?",
    phraseTaxRefund: "请问这里可以办理退税吗？",
    phraseTaxRefundSub: "taeg-seu-li-peon-deu doe-na-yo?",
    phraseCall1330: "请帮我接通 1330 中文翻译热线。",
    phraseCall1330Sub: "tong-yeok an-nae-won(1330) yeon-gyeol-hae ju-se-yo.",
    phraseHowMuch: "请问这个多少钱？",
    phraseHowMuchSub: "i-geo eol-ma-in-ga-yo?",
    phraseNoSpicy: "请不要放辣（微辣）。",
    phraseNoSpicySub: "an maep-ge hae-ju-se-yo.",
    // --- Monetization & Travelpayouts (ZH) ---
    promoBannerText: "🔥 [特惠] 韩国5G无限流量eSIM与热门一日游通行证 最高5折 ➔",
    specialDealsForSpot: "🎁 本咨询处周边特惠预订与旅行福利",
    dealTours: "🎟️ 特惠一日游 (KKday)",
    dealHotels: "🏨 周边特惠酒店 (Trip.com)",
    dealTiqets: "🏛️ Tiqets 古宫与景点门票",
    dealEsim: "📱 5G无限流量eSIM (Airalo)",
    dealWelcomePickups: "🚐 机场专车接送 (Welcome Pickups)",
    dealKiwi: "✈️ 特惠机票搜索 (Kiwi.com)",
    dealLuggage: "🧳 机场行李配送 (Goodlugg)",
    dealApplyNow: "特惠申领",
    expenseSavingsTip: "💡 省钱小贴士：使用Klook/KKday通行证，门票与行程立省高达50%！",
    converterBenefit: "💸 0汇率手续费旅行卡与韩国5G无限流量eSIM即买即用",
    // --- Viral & Foreigner Toolkit & Marketing (ZH) ---
    showToTaxi: "🚖 出示给出租车司机",
    taxiCardTitle: "出租车司机目的地指引卡",
    taxiCardHeader: "师傅，请带我去这里！",
    taxiCardSubHeader: "感谢您的安全驾驶与热情服务。",
    taxiCardDestination: "目的地名称",
    taxiCardAddress: "道路名地址",
    taxiCardPhone: "咨询处/设施电话",
    btnCopyAddress: "复制地址",
    btnShare: "分享",
    btnShareCard: "📲 分享给好友/社交平台",
    sharedSuccess: "✨ 分享链接已复制到剪贴板！",
    btnApple: "Apple Maps",
    cheatSheetBtn: "💡 旅行宝典",
    cheatSheetTitle: "💡 韩国旅行 必备生存宝典",
    cheatSheetSubtitle: "专为赴韩旅行者准备的实用技巧、交通攻略与便民指南",
    csTransitTitle: "💳 1. 交通卡全面指南 (T-money vs 气候同行卡 vs WOWPASS)",
    csTransitDesc: "• T-money / WOWPASS: 全韩地铁、公交、出租车及便利店通用。可在地铁站自动充值机或便利店使用现金(KRW)充值。\n• 气候同行卡 (Climate Card): 适用于首尔市内地铁及公交，在指定天数内无限次乘坐（可在咨询处及便利店购买）。",
    csTaxTitle: "🧾 2. 即时退税与免税技巧 (Tax Refund)",
    csTaxDesc: "• 在标有Tax Free的店铺单笔消费满15,000韩元以上，结账时出示护照即可享受现场即时免税扣减。\n• 机场离境大厅的自助退税机扫描小票条形码也能快速完成退税。",
    csLuggageTitle: "🧳 3. 智能行李寄存技巧 (咨询处免费寄存与T-Locker)",
    csLuggageDesc: "• 全韩572处旅游咨询中心中多数据点提供免费或优惠的行李寄存服务。\n• 各大地铁站内的智能寄存柜(T-Locker)让您轻松无负担游览。",
    csTippingTitle: "🙅 4. 无小费文化与餐桌呼叫铃",
    csTippingDesc: "• 韩国所有餐厅、出租车均无需支付任何小费（价格已包含税金及服务费）。\n• 在餐厅就餐时，按下桌角的小呼叫铃即可唤来服务员。",
    csHotlineTitle: "📞 5. 24小时 1330 免费中文旅游翻译热线",
    csHotlineDesc: "• 韩国旅游发展局提供365天24小时免费中/英/日/韩多语言电话翻译、路线指引与紧急求助（电话直拨: 1330）。",
    pwaInstallBannerText: "📲 1秒添加到手机主屏幕，无需下载离线畅享全套旅行神器！",
    pwaInstallBtn: "安装应用",
    pwaDismissBtn: "以后再说",
    // --- PWA Installation Guide (ZH) ---
    pwaGuideTitle: "📲 如何将应用添加到主屏幕",
    pwaGuideSubtitle: "无需通过应用商店下载，1秒即可像原生应用一样轻松安装",
    pwaStepIos: "🍎 苹果 iPhone / iPad (Safari) 用户",
    pwaStepIosDesc: "1. 点击Safari底部的**分享按钮 ⎘**。\n2. 向下滚动并选择**[添加到主屏幕 ➕]**。\n3. 点击右上角的**[添加]**即可完成安装！",
    pwaStepAndroid: "🤖 安卓 (Chrome / 三星浏览器) 用户",
    pwaStepAndroidDesc: "1. 点击浏览器右上角的**菜单 ⋮**。\n2. 选择**[安装应用]**或**[添加到主屏幕]**。\n3. 确认后即可在手机主屏幕上生成应用图标！",
    pwaStepPc: "💻 电脑端 (Chrome, Edge) 用户",
    pwaStepPcDesc: "1. 点击地址栏右侧的**[安装 📥]**图标。\n2. 点击**[安装]**即可作为独立的桌面应用运行！",
    btnGotIt: "我知道了"
  }
};

let currentLang = 'ko';

export function getLanguage() {
  return currentLang;
}

export function setLanguage(lang) {
  if (translations[lang]) {
    currentLang = lang;
    localStorage.setItem('k_tourspot_lang', lang);
    document.documentElement.lang = lang;
    updateDOMTranslations();
    return true;
  }
  return false;
}

export function initLanguage() {
  const saved = localStorage.getItem('k_tourspot_lang');
  if (saved && translations[saved]) {
    currentLang = saved;
  } else {
    const browserLang = (navigator.language || 'ko').toLowerCase();
    if (browserLang.startsWith('en')) currentLang = 'en';
    else if (browserLang.startsWith('ja')) currentLang = 'ja';
    else if (browserLang.startsWith('zh')) currentLang = 'zh';
    else currentLang = 'ko';
  }
  document.documentElement.lang = currentLang;
  updateDOMTranslations();
}

export function t(key, params = {}) {
  const dict = translations[currentLang] || translations.ko;
  let text = dict[key] || translations.ko[key] || key;
  for (const [k, v] of Object.entries(params)) {
    text = text.replace(new RegExp(`\\{${k}\\}`, 'g'), v);
  }
  return text;
}

export function updateDOMTranslations() {
  const elements = document.querySelectorAll('[data-i18n]');
  elements.forEach(el => {
    const key = el.getAttribute('data-i18n');
    el.textContent = t(key);
  });

  const placeholders = document.querySelectorAll('[data-i18n-placeholder]');
  placeholders.forEach(el => {
    const key = el.getAttribute('data-i18n-placeholder');
    el.placeholder = t(key);
  });

  const titles = document.querySelectorAll('[data-i18n-title]');
  titles.forEach(el => {
    const key = el.getAttribute('data-i18n-title');
    el.title = t(key);
  });
}
